import {
  GET_PARTNERS_FAILED,
  GET_PARTNERS_START,
  GET_PARTNERS_SUCCESS,
} from 'constants/action-types/projects/getPartners';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_PARTNERS_START:
      return {
        ...state,
        projectPartners: {
          ...state.projectPartners,
          loading: true,
          error: null,
        },
      };
    case GET_PARTNERS_FAILED:
      return {
        ...state,
        projectPartners: {
          ...state.projectPartners,
          error: payload,
          loading: false,
        },
      };
    case GET_PARTNERS_SUCCESS:
      return {
        ...state,
        projectPartners: {
          ...state.projectPartners,
          items: payload.data,
          meta: payload.meta,
          loading: false,
        },
      };
    default:
      return null;
  }
};
